export function isDesktop() {
    if (typeof fin !== "undefined" &&
        typeof fin?.InterApplicationBus !== "undefined")
        return true;
    return false;
}
export async function openTabWindow(id, width, height) {
    const url = `${window.location.origin}/pop-out?v=${btoa(id)}`;
    return window.open(url, id, `toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height},top=${window.screen.height / 2 - height / 2}+",left=${window.screen.width / 2 - width / 2}`);
}
